module.exports = __webpack_public_path__ + "static/media/editor-preview-bg-1920x1080.e20939cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/editor-preview-bg-1920x1080.jpg
// module id = 402
// module chunks = 37